export const area = {
    label: {
        visible: !1,
        offset: 5,
        position: "top",
        style: {
            stroke: {
                type: "palette",
                key: "backgroundColor"
            },
            lineWidth: 2
        }
    },
    point: {
        style: {
            symbolType: "circle"
        }
    },
    seriesMark: "area"
};
//# sourceMappingURL=area.js.map
